// extracted by mini-css-extract-plugin
var _1 = "PhoneCallButton-module__active--VBi0I";
var _2 = "PhoneCallButton-module__button--_6vAj";
var _3 = "PhoneCallButton-module__buttonText--QLjf6";
var _4 = "PhoneCallButton-module__root--pggxN";
export { _1 as "active", _2 as "button", _3 as "buttonText", _4 as "root" }
